"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSanitizedOptions = void 0;
const defaultOptions = {
    delayFirstAttempt: false,
    jitter: "none",
    maxDelay: Infinity,
    numOfAttempts: 10,
    retry: () => true,
    startingDelay: 100,
    timeMultiple: 2
};
function getSanitizedOptions(options) {
    const sanitized = Object.assign(Object.assign({}, defaultOptions), options);
    if (sanitized.numOfAttempts < 1) {
        sanitized.numOfAttempts = 1;
    }
    return sanitized;
}
exports.getSanitizedOptions = getSanitizedOptions;
